export const ADD_COMMENT = 'ADD_COMMENT';
export const HOMES_LOADING = 'HOMES_LOADING';
export const HOMES_FAILED = 'HOMES_FAILED';
export const ADD_HOMES = 'ADD_HOMES';
export const HOTELS_LOADING = 'HOTELS_LOADING';
export const HOTELS_FAILED = 'HOTELS_FAILED';
export const ADD_HOTELS = 'ADD_HOTELS';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const COMMENTS_FAILED = 'COMMENTS_FAILED';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
